import { render, staticRenderFns } from "./diseaseTypeNew.vue?vue&type=template&id=3a2a344a"
import script from "./diseaseTypeNew.vue?vue&type=script&lang=js"
export * from "./diseaseTypeNew.vue?vue&type=script&lang=js"
import style0 from "./diseaseTypeNew.vue?vue&type=style&index=0&id=3a2a344a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports